export const PARTNER_SCOPE_OPTIONS = [
  { id: "personnel.read", label: "personnel.read" },
  { id: "auth.login", label: "auth.login" },
];

export const PARTNER_SCOPE_LABELS: Record<string, string> = Object.fromEntries(
  PARTNER_SCOPE_OPTIONS.map((option) => [option.id, option.label]),
);
